import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faSync } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../../basics/interface/CustomModal"
import {
	couvertureVersMission,
	statutCouverture,
} from "../../../store/actions/couverturesActions"
import { Apercu, ui } from "./couverturesUi"

const boutonEtat = (etat, libelle) =>
	etat.saving ? (
		<FontAwesomeIcon icon={faSync} spin />
	) : etat.saved ? (
		<FontAwesomeIcon icon={faCheck} />
	) : (
		libelle
	)

// « C'est une nouvelle intervention » (GE-60 §5.2, maquette #m-nouvelle) :
// aperçu calculé par le serveur (plan simulé), puis application avec la
// même base (péremption).
export const NouvelleInterventionModal = ({
	couverture: c,
	sousTitre,
	onClose,
	onDone,
}) => {
	const dispatch = useDispatch()
	const [plan, setPlan] = useState(null)
	const [etat, setEtat] = useState({ saving: false, saved: false })
	const [erreur, setErreur] = useState(null)

	useEffect(() => {
		dispatch(couvertureVersMission(c.id, { simuler: true })).then((res) => {
			if (!res || res.erreur) setErreur(res && res.erreur)
			else setPlan(res)
		})
	}, [dispatch, c.id])

	const valider = () => {
		if (!plan || plan.refus || etat.saving || etat.saved) return
		setErreur(null)
		setEtat({ saving: true, saved: false })
		dispatch(couvertureVersMission(c.id, { base: plan.base })).then(
			(res) => {
				if (!res || res.erreur) {
					setErreur(res && res.erreur)
					setEtat({ saving: false, saved: false })
					return
				}
				setEtat({ saving: false, saved: true })
				setTimeout(() => onDone(res), 600)
			},
		)
	}

	return (
		<CustomModal
			title="C'est une nouvelle intervention"
			subtitle={sousTitre}
			onClose={etat.saving ? () => {} : onClose}
			showCloseButton={!etat.saving}
			maxWidth={600}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: onClose,
					disabled: etat.saving,
				},
				{
					title: boutonEtat(etat, "Créer l'intervention"),
					styleName: "primary",
					onClick: valider,
					disabled:
						!plan || !!plan.refus || etat.saving || etat.saved,
				},
			]}
		>
			{plan ? (
				plan.refus ? (
					<div style={{ ...ui.erreur, marginTop: 0 }}>
						{plan.refus}
					</div>
				) : (
					<Apercu lignes={plan.apercu} style={{ marginTop: 0 }} />
				)
			) : !erreur ? (
				<Apercu
					lignes={[]}
					vide="Calcul de l'effet…"
					style={{ marginTop: 0 }}
				/>
			) : null}
			<div style={ui.warnbox}>
				ⓘ Impossible si un encaissement est déjà lié à cette couverture
				: l'annuler d'abord.
			</div>
			{erreur && (
				<div style={ui.erreur}>
					{erreur.message || "L'opération a échoué."}
				</div>
			)}
		</CustomModal>
	)
}

// Annuler / Valider / Rejeter une couverture : modal de confirmation du menu
// ⋯ ou du bandeau « À valider » (règle UI V2 : bouton hors modal → modal).
const TEXTES = {
	annuler: {
		titre: "Annuler la couverture",
		question:
			"La couverture sera annulée (grisée, conservée dans l'historique de la carte).",
		bouton: "Annuler la couverture",
		style: "danger",
	},
	rejeter: {
		titre: "Rejeter la couverture",
		question:
			"La couverture proposée sera rejetée (conservée dans l'historique).",
		bouton: "Rejeter",
		style: "danger",
	},
	valider: {
		titre: "Valider la couverture",
		question: "La couverture devient active : elle compte dans les totaux.",
		bouton: "Valider",
		style: "primary",
	},
}

export const StatutCouvertureModal = ({
	couverture: c,
	action,
	sousTitre,
	onClose,
	onDone,
}) => {
	const dispatch = useDispatch()
	const t = TEXTES[action]
	const [motif, setMotif] = useState("")
	const [etat, setEtat] = useState({ saving: false, saved: false })
	const [erreur, setErreur] = useState(null)

	const valider = () => {
		if (etat.saving || etat.saved) return
		setErreur(null)
		setEtat({ saving: true, saved: false })
		dispatch(statutCouverture(c.id, action, motif.trim())).then((res) => {
			if (!res || res.erreur) {
				setErreur(res && res.erreur)
				setEtat({ saving: false, saved: false })
				return
			}
			setEtat({ saving: false, saved: true })
			setTimeout(() => onDone(res), 500)
		})
	}

	return (
		<CustomModal
			title={t.titre}
			subtitle={sousTitre}
			onClose={etat.saving ? () => {} : onClose}
			showCloseButton={!etat.saving}
			maxWidth={520}
			buttons={[
				{
					title: "Fermer",
					styleName: "secondary",
					onClick: onClose,
					disabled: etat.saving,
				},
				{
					title: boutonEtat(etat, t.bouton),
					styleName: t.style,
					onClick: valider,
					disabled: etat.saving || etat.saved,
				},
			]}
		>
			<div style={{ fontSize: 13.5 }}>{t.question}</div>
			{action !== "valider" && (
				<div style={{ marginTop: 12 }}>
					<label style={ui.fieldLabel}>Motif (facultatif)</label>
					<input
						style={ui.input}
						value={motif}
						onChange={(e) => setMotif(e.target.value)}
						maxLength={300}
						autoFocus
					/>
				</div>
			)}
			{erreur && (
				<div style={ui.erreur}>
					{erreur.message || "L'opération a échoué."}
				</div>
			)}
		</CustomModal>
	)
}
